import ShButton from '@/components/Helpers/ShButton';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import NumberVerificationForm from '@/components/AgentsAndNumbers/NumberVerificationForm';

export default {
  name: 'ConfigurationModalStepThree',

  components: {
    ShButton,
    ShModalWindow,
    NumberVerificationForm,
  },

  data() {
    return {
      isVerificationVisible: false,
      form: {
        number: '',
      },
      rules: {
        number: { required: true, validator: this.numberValidator, trigger: 'blur' },
      },
      numberForVerification: null,
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes(
        'numbers/create',
        'numbers/getList',
      );
    },
  },
  methods: {
    handleSave() {
      this.isVerificationVisible = true;
    },
    async handleAddNewNumber() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          const newNumber = await this.$store.dispatch('numbers/create', this.form.number);
          await this.$store.dispatch('numbers/getList');
          this.$notify.success({
            title: 'Dodanie nowego numeru',
            message: `Dodano numer: ${this.form.number}`,
            customClass: 'callmeweb-notification',
          });
          this.numberForVerification = {
            ...newNumber,
            isConfigModal: true,
          };
          this.isVerificationVisible = true;
        }
      });
    },
    handleAddNewAgent(numberToBeAssigned) {
      this.$emit('numberToBeAssigned', numberToBeAssigned);
      this.$emit('goToSetp', 4);
    },
    numberValidator(rule, value, callback) {
      if (!this.form.number) {
        callback(new Error('Numer jest wymagany'));
      }
      if (!(/^\d{9}$/).test(value)) {
        callback(new Error('Prawidłowy numer telefonu zawiera 9 cyfr'));
      }
      callback();
    },
  },
};
